import { observer, Observer } from 'mobx-react-lite'
import type { IColumn } from 'shared/ui/TableNew'
import { EmptyCell, Typography } from 'shared/ui'
import { AiCallingStatus } from 'entities/AICalling/ui/AiCallingStatus/AiCallingStatus'
import { CallingActiveToggle } from 'pages/chatbot/pages/calling/ui/CallingActiveToggle'
import { type CallingListItem } from '../store/CallingListItem'
import styles from './styles.module.scss'

const NameCell = observer(({ row }: { row: CallingListItem }) => (
  <div className={styles.nameCellWrapper}>
    <Typography
      variant={'body-md-regular'}
      ellipsis
      tooltipProps={{
        label: row.name,
      }}
      ariaLabel={'name'}
      className={styles.nameText}
    >
      {row.name}
    </Typography>
    <CallingActiveToggle
      item={row.origin}
      onSuccessUpdate={row.syncOrigin}
      className={styles.nameToggle}
    />
  </div>
))

export const columns: IColumn<CallingListItem>[] = [
  {
    field: 'name',
    name: 'Name',
    width: '100%',
    minWidth: '260px',
    maxWidth: '260px',
    renderRowCell: (row) => <NameCell row={row} />,
  },
  {
    field: 'status',
    name: 'Status',
    minWidth: '150px',
    renderRowCell: (row) => <Observer>{() => <AiCallingStatus status={row.status} />}</Observer>,
  },
  {
    field: 'totalCals',
    name: 'Total calls',
    minWidth: '150px',
    renderRowCell: (row) => <Observer>{() => <>{row.totalCals || <EmptyCell />}</>}</Observer>,
  },
  {
    field: 'resolvedCalls',
    name: 'Resolved',
    minWidth: '150px',
    renderRowCell: (row) => <Observer>{() => <>{row.resolvedCalls}</>}</Observer>,
  },
  {
    field: 'handedOffCalls',
    name: 'Handed off',
    minWidth: '150px',
    renderRowCell: (row) => <Observer>{() => <>{row.handedOffCalls}</>}</Observer>,
  },
  {
    field: 'abandonedCalls',
    name: 'Abandoned',
    minWidth: '150px',
    renderRowCell: (row) => <Observer>{() => <>{row.abandonedCalls}</>}</Observer>,
  },
]
